/**
 * Dev-only logger — a thin wrapper around `console` that no-ops in production
 * builds (Create-React-App strips `process.env.NODE_ENV === "development"`
 * branches via dead-code elimination, so nothing leaks to end users).
 *
 * Use everywhere instead of raw `console.warn` / `console.error` so we don't
 * ship developer-facing traces to prod users.
 */
const isDev = process.env.NODE_ENV === "development";

export const devLog = {
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
};
